import {computed, inject, Service} from '@angular/core'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {KUNDCENTER} from '../application/types'

@Service()
export class RoleHelperService {

  /*public handlaggare = computed(() => {
    return this.service.roles().includes(HANDLAGGARE)
  })*/
  public kundcenter = computed(() => {
    return this.service.roles().includes(KUNDCENTER)
  })

  private readonly service = inject(ConfigService)
}
